export default __webpack_public_path__ + "static/media/36I-102814_-16004_0.d371849b.jpg";